import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useAuth from '../../hook/useAuth';
import { FileDrop } from '../../components/FileDrop';
import AdminFamilyMemberList from './AdminFamilyMemberList';
import { getMember, put_Member } from '../../services/Member';
import baseURL from '../../config/api';
import AddAdminFamilyMember from './AddAdminFamilyMember';
import EditAdminFamilyMember from './EditAdminFamilyMember';
import { formatUSPhone, handleUSPhoneChange } from '../../utils/phoneFormatter';
import { useUSPhoneValidation } from '../../hook/useUSPhoneValidation';
import useGroup from '../../hook/useGroup';
import Cookies from 'js-cookie';
import LocationFields from '../../components/LocationFields';

enum CurrentPage {
  ADD_FAMILY,
  ADD,
  EDIT
};

const EditAdminMember = () => {
  const token = Cookies.get("token-my-cdir");
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { auth }: any = useAuth();
  const { selectedGroupId }: any = useGroup();
  const [currentpage, setCurrentPage] = useState<CurrentPage>(CurrentPage.ADD_FAMILY);
  const [familyMember, setFamilyMember] = useState<any[]>([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number>(-1);
  const [userData, setUserData] = useState<any>({
    familyName: "",
    firstName: "",
    lastName: "",
    userName: "",
    emailAddress: "",
    phoneNumber: "",
    birthday: "",
    imagePath: "",
    street: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    zip: "",
    groupId: 0,
    imageSize: 0,
    createdAt: "",
    createdBy: "",
    uploadedAt: "",
    uploadedBy: ""
  });

  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const {
    isValid: isPhoneValid,
    touched: phoneTouched,
    setTouched: setPhoneTouched
  } = useUSPhoneValidation(userData.phoneNumber);

  useEffect(() => {
    if (id) {
      getMember(id, token!.toString())
        .then(res => {
          const newFamilyMembers = res?.familyMembers?.map((item: any) => ({
            ...item,
            familyMemberSubGroups: item?.familyMemberSubGroups?.map((fms: any) => ({ value: fms?.subGroupId }))
          })) || [];

          setUserData({
            ...res,
            birthday: res?.birthday
              ? res.birthday.split("T")[0]
              : "",
            imagePath: res?.imagePath ? res.imagePath : "",
            familyMembers: newFamilyMembers
          });

          setFamilyMember(newFamilyMembers);
        })
        .catch(error => console.error(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location])

  const closeModal = () => navigate(-1);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isProcessing) {
      setIsProcessing(true);

      delete userData.familyMembers;

      put_Member({
        ...userData,
        groupId: selectedGroupId,
        imagePath: userData?.imagePath?.replace(`${baseURL}commonFile/Get?name=`, ""),
        createdAt: new Date().toISOString(),
        createdBy: auth?.givenname,
        uploadedAt: new Date().toISOString(),
        uploadedBy: auth?.givenname
      }, token!.toString())
        .then(() => {
          setIsProcessing(false);
          navigate(-1);
        })
        .catch(error => {
          setIsProcessing(false);
          console.error(error);
        });
    }
  }

  return (
    <div className="w-full">
      <div className="my-2">
        <div className="mx-auto max-w-6xl  relative bg-white">
          <h2 className={`text-xl text-secondary font-bold ${currentpage === CurrentPage.ADD_FAMILY ? "block" : "hidden"}`}>Edit Family</h2>

          <div className={`family__member__list__container ${currentpage === CurrentPage.ADD_FAMILY ? "block" : "hidden"}`}>
            <AdminFamilyMemberList
              setCurrentPage={setCurrentPage}
              familyMember={familyMember}
              setFamilyMember={setFamilyMember}
              setSelectedRowIndex={setSelectedRowIndex}
              fromEdit={true}
            />
          </div>

          {currentpage === CurrentPage.ADD_FAMILY && (
            <form onSubmit={handleSubmit} className="mt-8 grid xm:grid-cols-2 gap-6 text-secondary">
              <div>
                <label className="font-semibold text-sm">Family Name</label>
                <input type='text' placeholder='Enter Family Name'
                  className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                  value={userData.familyName}
                  onChange={(e) => setUserData({ ...userData, familyName: e.target.value })}
                  required
                />
              </div>
              <br className='md:block hidden' />
              <div>
                <label className="font-semibold text-sm">First Name</label>
                <input type='text' placeholder='Enter First Name'
                  className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                  value={userData.firstName}
                  onChange={(e) => setUserData({ ...userData, firstName: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="font-semibold text-sm">Last Name</label>
                <input type='text' placeholder='Enter Last Name'
                  className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                  value={userData.lastName}
                  onChange={(e) => setUserData({ ...userData, lastName: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="font-semibold text-sm">Email</label>
                <input type='email' placeholder='Email'
                  className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                  value={userData.emailAddress}
                  onChange={(e) => setUserData({ ...userData, emailAddress: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="font-semibold text-sm">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={formatUSPhone(userData.phoneNumber)}
                  onChange={(e) => {
                    setPhoneTouched(true);
                    handleUSPhoneChange(e, (digits) =>
                      setUserData((prev: any) => ({
                        ...prev,
                        phoneNumber: digits,
                      }))
                    );
                  }}
                  required
                  className="w-full rounded py-2.5 px-4 border-2 mt-2 text-sm text-black outline-secondary"
                  placeholder="Phone No."
                />

                {!isPhoneValid && phoneTouched && (
                  <p className="text-xs text-red-500 mt-1">
                    Please enter a valid 10-digit phone number
                  </p>
                )}
              </div>

              <div>
                <label className="font-semibold text-sm">Street</label>
                <input type='text' placeholder='Street'
                  className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                  value={userData.street}
                  onChange={(e) => setUserData({ ...userData, street: e.target.value })}
                  required
                />
              </div>
              <div>
                <label className="font-semibold text-sm">Street 2</label>
                <input type='text' placeholder='Street 2'
                  className="w-full rounded py-2.5 px-4 mt-2 border-2 text-sm text-black outline-secondary"
                  value={userData.street2}
                  onChange={(e) => setUserData({ ...userData, street2: e.target.value })}
                />
              </div>
                 <LocationFields
                  userData={userData}
                  setUserData={setUserData}
                />
              <div >
                <FileDrop
                  value={userData.imagePath}
                  setValue={(value) => setUserData({ ...userData, imagePath: value })}
                />
              </div>
              <div />

              <div className="flex max-xm:flex-col gap-4 !mt-4">
                <button
                  type="button"
                  className="px-6 py-2 min-w-[150px] rounded text-black text-sm font-semibold border-none outline-none bg-gray-200 hover:bg-gray-300 active:bg-gray-200"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 min-w-[150px] rounded text-white text-sm font-semibold border-none outline-none bg-secondary hover:bg-custom-blue"
                >
                  {isProcessing ?
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18px" fill="#fff" className="mr-2 inline animate-spin"
                        viewBox="0 0 26.349 26.35">
                        <circle cx="13.792" cy="3.082" r="3.082" data-original="#000000" />
                        <circle cx="13.792" cy="24.501" r="1.849" data-original="#000000" />
                        <circle cx="6.219" cy="6.218" r="2.774" data-original="#000000" />
                        <circle cx="21.365" cy="21.363" r="1.541" data-original="#000000" />
                        <circle cx="3.082" cy="13.792" r="2.465" data-original="#000000" />
                        <circle cx="24.501" cy="13.791" r="1.232" data-original="#000000" />
                        <path
                          d="M4.694 19.84a2.155 2.155 0 0 0 0 3.05 2.155 2.155 0 0 0 3.05 0 2.155 2.155 0 0 0 0-3.05 2.146 2.146 0 0 0-3.05 0z"
                          data-original="#000000" />
                        <circle cx="21.364" cy="6.218" r=".924" data-original="#000000" />
                      </svg>
                      Processing...
                    </>
                    :
                    "Save"
                  }
                </button>
              </div>
            </form>
          )
          }

          {currentpage === CurrentPage.ADD &&
            <div className={`add__family__member__container ${currentpage === CurrentPage.ADD ? "block" : "hidden"}`}>
              <AddAdminFamilyMember
                familyMember={familyMember}
                setFamilyMember={setFamilyMember}
                setCurrentPage={setCurrentPage}
                fromEdit={true}
              />
            </div>
          }

          {currentpage === CurrentPage.EDIT &&
            <div className={`edit__family__member__container ${currentpage === CurrentPage.EDIT ? "block" : "hidden"}`}>
              <EditAdminFamilyMember
                setCurrentPage={setCurrentPage}
                familyMemberValue={familyMember[selectedRowIndex]}
                familyMember={familyMember}
                setFamilyMember={setFamilyMember}
                selectedRowIndex={selectedRowIndex}
                fromEdit={true}
              />
            </div>
          }

        </div>
      </div>
    </div>
  )
}
export default EditAdminMember